module.exports = "input.ng-invalid.ng-touched {\r\n\tborder: 1px solid red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/signin/signin.component.css
// module id = ./src/app/auth/signin/signin.component.css
// module chunks = main